import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManagerCouponsSharePageRoutingModule } from './manager-coupons-share-routing.module';

import { ManagerCouponsSharePage } from './manager-coupons-share.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManagerCouponsSharePageRoutingModule
  ],
  declarations: [ManagerCouponsSharePage]
})
export class ManagerCouponsSharePageModule {}
